<script setup>
    import { Cog6ToothIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <Cog6ToothIcon />
</template>
